import {
	useObserveRef,
	useObservableRef,
	useThrottledCallback,
} from '@chkp/mwc-common';

// Temporary hard-coded everywhere.
const SCROLLBAR_WIDTH = 10;
const SCROLLBAR_HEIGHT = 10;

/**
 * Grid sizing processor
 * @returns {{hasScrollXObservable, totalWidthObservable, contentWidthObservable, contentHeightObservable, availableWidthObservable, totalHeightObservable, availableHeightObservable, hasScrollYObservable}}
 */
const useSizing = () => {
	// Inputs
	const totalColumnsWidthObservable = useObservableRef();
	const totalRowsHeightObservable = useObservableRef();
	const availableWidthObservable = useObservableRef();
	const availableHeightObservable = useObservableRef();

	// Outputs
	const totalWidthObservable = useObservableRef();
	const totalHeightObservable = useObservableRef();
	const hasScrollXObservable = useObservableRef();
	const hasScrollYObservable = useObservableRef();
	const contentWidthObservable = useObservableRef();
	const contentHeightObservable = useObservableRef();

	// Update sizing in response to inputs change
	const updateSizing = useThrottledCallback(() => {
		const totalColumnsWidth = totalColumnsWidthObservable.current || 0;
		const totalRowsHeight = totalRowsHeightObservable.current || 0;
		const availableWidth = availableWidthObservable.current || 0;
		const availableHeight = availableHeightObservable.current || 0;
		const hasScrollY = availableHeight < totalRowsHeight;
		const hasScrollX =
			availableWidth - (hasScrollY ? SCROLLBAR_WIDTH : 0) < totalColumnsWidth;
		const totalWidth = totalColumnsWidth + (hasScrollY ? SCROLLBAR_WIDTH : 0);
		const totalHeight = totalRowsHeight + (hasScrollX ? SCROLLBAR_HEIGHT : 0);

		const contentWidth = Math.max(
			0,
			availableWidth - (hasScrollY ? SCROLLBAR_WIDTH : 0),
		);
		const contentHeigth = Math.max(
			0,
			availableHeight - (hasScrollX ? SCROLLBAR_HEIGHT : 0),
		);

		// console.log('sizing', {
		// 	totalColumnsWidth,
		// 	totalRowsHeight,
		// 	availableWidth,
		// 	availableHeight,
		// 	hasScrollX,
		// 	hasScrollY,
		// 	totalWidth,
		// 	totalHeight,
		// 	contentWidth,
		// 	contentHeigth,
		// });

		totalWidthObservable.current = totalWidth;
		totalHeightObservable.current = totalHeight;
		hasScrollXObservable.current = hasScrollX;
		hasScrollYObservable.current = hasScrollY;
		contentWidthObservable.current = contentWidth;
		contentHeightObservable.current = contentHeigth;
	}, 16);

	useObserveRef(totalColumnsWidthObservable, updateSizing);
	useObserveRef(totalRowsHeightObservable, updateSizing);
	useObserveRef(availableWidthObservable, updateSizing);
	useObserveRef(availableHeightObservable, updateSizing);

	return {
		totalColumnsWidthObservable,
		totalRowsHeightObservable,
		availableWidthObservable,
		availableHeightObservable,
		totalWidthObservable,
		totalHeightObservable,
		hasScrollXObservable,
		hasScrollYObservable,
		contentWidthObservable,
		contentHeightObservable,
	};
};

export { useSizing };
